module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/22-1e209cfe42c1bb49fb38b6399994f948.jpg";